// extracted by mini-css-extract-plugin
export default {"SignupButton":"SignupButton_SignupButton__U3vLc","button":"SignupButton_button__CfIrV"};